// AI Service Codes
export const AI_SERVICE_CODES = {
    CAR_PARK_MONITORING: "20230222000000000008",
    COMMON_OBJECT_DETECTION: "20230222000000000004",
};

// Notification Type Codes
export const NOTIFICATION_CODES = {
    FACE_RECOGNITION: "CODE_12",
    LICENSE_PLATE_RECOGNITION: "CODE_10",
    CAR_PARK: "CODE_2",
};

// AI Config Codes
export const AI_CONFIG_CODES = {
    SHOW_PARKING_POSITION: 31,
    SHOW_REGION: 33,
};

// HLS Configuration
export const HLS_CONFIG = {
    enableWorker: true,
    lowLatencyMode: true,
    maxBufferSize: 2 * 1000 * 1000,
};

// Protocol Types
export const PROTOCOL_TYPES = {
    HLS: "hls",
    WEBRTC: "webrtc",
};

// Default Colors
export const DEFAULT_NOTIFICATION_COLOR = "#0400ff";

